export enum PassageCounterType {
  FreeEntrance = 'FreeEntrance',
  FreeExit = 'FreeExit',
  UnauthorizedEntrance = 'UnauthorizedEntrance',
  UnauthorizedExit = 'UnauthorizedExit',
  TicketEntrance = 'TicketEntrance',
  TicketExit = 'TicketExit',
}
